import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { AuthService } from './auth.service';

export const platformAdminGuard: CanActivateFn = async (_route, state) => {
    const auth = inject(AuthService);
    const router = inject(Router);

    await auth.ready;

    if (!auth.isAuthenticated()) {
        return router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } });
    }

    const profile = await firstValueFrom(
        auth.profile$.pipe(filter((p) => p !== null), take(1)),
    );

    if (profile?.role === 'PLATFORM_ADMIN') {
        return true;
    }

    return router.createUrlTree(['/sites']);
};
